import { render, staticRenderFns } from "./OrderReceiverInfo.vue?vue&type=template&id=66dd2ba8&"
import script from "./OrderReceiverInfo.vue?vue&type=script&lang=ts&"
export * from "./OrderReceiverInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports